const GET_IKU_START = "GET_IKU_START"
const GET_IKU_SUCCESS = "GET_IKU_SUCCESS"
const GET_IKU_FAILED = "GET_IKU_FAILED"

export {
    GET_IKU_START,
    GET_IKU_SUCCESS,
    GET_IKU_FAILED
}